import React, { useState } from 'react'
import { Checkbox, Modal, Tooltip } from 'antd'
import { kasaRights } from '../../../components/_utils/appUtils'
import { createUnconditionalOfferLetterFxn } from '../actions/chooseStudent'
import { useDispatch } from 'react-redux'
import moment from 'moment'

const AcceptUnconditionalOfferLetter = (props) => {
  let { file, record, onRefresh, showBtn = true } = props
  let dispatch = useDispatch()
  let message = 'Once you accept the unconditional offer letter, the college will block your seat. You are required to apply for this student visa through UnizPortal. Failure to do so may result in the suspension of your account in the future.'
  const createUnconditionalOfferLetter = async () => {
    let obj = {
      studentId: record._id,
      applicationId: record.applications._id
    }
    let resp = await dispatch(createUnconditionalOfferLetterFxn(obj))
    if (resp && resp.success) {
      onRefresh()
    }
  }
  const confirmModal = (data) => {
    let confirmed = false

    const modal = Modal.confirm({
      width: '35%',
      title: (
        <div style={{ fontWeight: 'bold', fontSize: '18px', textDecoration: 'underline' }}>
          Accept Unconditional Offer Letter
        </div>
      ),
      content: (
        <div>
          <p>{message}</p>
          <Checkbox
            onChange={(e) => {
              confirmed = e.target.checked
              modal.update({
                okButtonProps: {
                  disabled: !confirmed
                }
              })
            }}
          >
            I hereby confirm my acceptance of the offer letter.
          </Checkbox>
        </div>
      ),
      okText: 'Accept',
      okButtonProps: {
        disabled: true
      },
      onOk() {
        if (confirmed) {
          createUnconditionalOfferLetter(data)
        }
      },
      onCancel() {
        // Optional: handle cancel
      },
      afterClose: () => {
        confirmed = false // Reset for next use
      }
    })
  }

  return (
    <div style={{ width: 200 }} className={'fcmtDiv'}>
      <div className={'d-flex flex-column align-items-center alignCenter'}>
        {file && file.path ? (
            <Tooltip title={'Download Offer Letter'}>
              <a download={file.fileName} href={file.path}>
                <img src={'../assets/icons/cloud-computing-download.png'} />
              </a>
            </Tooltip>
          ) :
          !((record && record.applications && record.applications.isCaseCancelled) || (record && record.applications && record.applications.combinedSeatNumber)) ?
            showBtn && <div className={'alignCenter'}>
              <a className={'btn btn-default sm mt10 roundNew'}
                 onClick={confirmModal}>Accept</a>
            </div> : null
        }
        {
          record && record.applications.combinedSeatNumber &&
          <span className='btn btn-default xs roundNew2 mt10 mr0'>
            Seat No - {record.applications.combinedSeatNumber}
          </span>
        }
        {
          file && record.applications.combinedSeatNumber &&
          <span>
            Accepted On - {moment(file.date).format('DD/MM/YYYY')}
          </span>
        }
      </div>
    </div>
  )
}
export default AcceptUnconditionalOfferLetter
